import { render } from "./dispositivos-etiquetas.vue?vue&type=template&id=7d97e5f6"
import script from "./dispositivos-etiquetas.vue?vue&type=script&lang=js"
export * from "./dispositivos-etiquetas.vue?vue&type=script&lang=js"

import "./dispositivos-etiquetas.vue?vue&type=style&index=0&id=7d97e5f6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__